import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Spinner } from "reactstrap";
import { Link } from "react-router-dom";

const ActivityComp = () => {
  const [activities, setActivities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.HESAP_TURU === 'Admin';
  const userId = authUser?.ID;

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const token = localStorage.getItem("token") || authUser?.Token;

        if (!token) {
           setIsLoading(false);
           return;
        }

        const filterQuery = isAdmin ? "" : `$filter=SATICI_ID eq ${userId}&`;
        
        // 📌 ÇÖZÜM BURADA: Doğrudan KULLANICILAR yerine SIPARIS üzerinden KULLANICILAR'a ulaşıyoruz
        const url = `https://harmanappapi.stechomeyazilim.info/SIPARIS_TESLIMATLARI?${filterQuery}$orderby=ID desc&$top=5&$expand=SIPARIS($expand=KULLANICILAR)`;

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        // Eğer backend 400 dönerse hatayı daha net görmek için:
        if (!response.ok) {
           console.error("API Hatası:", await response.text());
           setIsLoading(false);
           return;
        }

        const result = await response.json();

        if (result && result.value) {
          const formattedData = result.value.map((item, index) => {
            
            const dateObj = item.OLUSTURMA_TARIHI ? new Date(item.OLUSTURMA_TARIHI) : new Date();
            const dateStr = dateObj.toLocaleDateString('tr-TR', { 
                day: '2-digit', 
                month: 'short',
                hour: '2-digit',
                minute: '2-digit'
            });
            
            // 📌 ÇÖZÜM 2: Veriyi çekerken de hiyerarşiye uygun çekiyoruz (item.SIPARIS.KULLANICILAR)
            const userName = item.SIPARIS?.KULLANICILAR?.AD_SOYAD || "Sistem";
            const status = item.TESLIMAT_DURUMU || "Güncellendi";
            const siparisId = item.SIPARIS_ID || item.ID || "Bilinmiyor";

            return {
              id: item.ID,
              date: dateStr,
              activity: `${userName}, #${siparisId} numaralı siparişin teslimat durumu güncellendi: ${status}`,
              active: index === 0
            };
          });

          setActivities(formattedData);
        }
      } catch (error) {
        console.error("Aktiviteler çekilirken hata oluştu:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (isAdmin || userId) {
        fetchActivities();
    } else {
        setIsLoading(false);
    }
  }, [isAdmin, userId, authUser?.Token]);

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-5">Son Aktiviteler</CardTitle>
          
          {isLoading ? (
            <div className="text-center py-4">
              <Spinner color="primary" size="sm" /> <span className="ms-2">Yükleniyor...</span>
            </div>
          ) : activities.length > 0 ? (
            <ul className="verti-timeline list-unstyled">
              {activities.map((item) => (
                <li className={`event-list ${item.active ? "active" : ""}`} key={item.id}>
                  <div className="event-timeline-dot">
                    <i className={`font-size-18 bx ${item.active ? "bxs-right-arrow-circle bx-fade-right" : "bx-right-arrow-circle"}`} />
                  </div>
                  <div className="flex-shrink-0 d-flex">
                    <div className="me-3">
                      <div className="font-size-14 fw-medium">
                        {item.date}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-muted">{item.activity}</div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className="text-muted text-center py-3">Henüz bir aktivite bulunmuyor.</div>
          )}

          <div className="text-center mt-4">
            <Link to="/teslimat-yonetimi" className="btn btn-primary waves-effect waves-light btn-sm">
              Tümünü Gör <i className="mdi mdi-arrow-right ms-1" />
            </Link>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default ActivityComp;